import { render, staticRenderFns } from "./Badge.vue?vue&type=template&id=77ac6e8e&scoped=true&"
import script from "./Badge.vue?vue&type=script&lang=ts&setup=true&"
export * from "./Badge.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./Badge.vue?vue&type=style&index=0&id=77ac6e8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ac6e8e",
  null
  
)

export default component.exports